(() => {
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'CartDrawer-Form') return;
    if (event.submitter?.name !== 'checkout') return;

    const discountInput = document.getElementById('CartDrawer-Discount');
    const discountCode = discountInput?.value.trim();
    if (!discountCode) return;

    event.preventDefault();

    const discountUrl = `${form.dataset.discountBaseUrl}${encodeURIComponent(discountCode)}`;
    const checkoutUrl = form.dataset.checkoutUrl;
    window.location.assign(`${discountUrl}?redirect=${encodeURIComponent(checkoutUrl)}`);
  });
})();
